import React from "react";
import { Box, Typography, Grid, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SearchIcon from "@mui/icons-material/Search";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import { useNavigate } from "react-router-dom";
import { HeaderContext } from "../../App";
import {  useEffect, useContext } from "react";

const Search = () => {
  const navigate = useNavigate();
  const { setTitle, setShowBack } = useContext(HeaderContext);
  const params = new URLSearchParams(window.location.search);
  const service = params.get('service'); 
  useEffect(() => {

    setTitle(`เลือกสัตว์${service=="vaccine" ?"(วัคซีน)" :"(ไมโครชิพ)"} `);
    setShowBack(true);

    return () => {
      setTitle("Bow HIS.");
      setShowBack(false);
    };
  }, [setTitle, setShowBack]);

  return (
    <>
   
    <Box sx={{ p: 2 }}>
      {/* Icons Row */}
      <Grid container spacing={2} sx={{ textAlign: "center", mb: 3 }}>
        <Grid item xs={6}>
          <Box onClick={() => navigate(`/search/word?service=${service}`)} sx={{ cursor: "pointer" }}>
            <SearchIcon sx={{ fontSize: 40 }} />
            <Typography>ค้นหา</Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box onClick={() => navigate(`/search/qr?service=${service}`)} sx={{ cursor: "pointer" }}>
            <QrCodeScannerIcon sx={{ fontSize: 40 }} />
            <Typography>คิวอาร์โค้ด</Typography>
          </Box>
        </Grid>
      </Grid>

      {/* Description Text */}
      <Box sx={{ px: 1 }}>
        <Typography sx={{ mb: 2 }}>
          *ค้นหาด้วย ชื่อ, Tel, Bow Pet ID, Microchip เฉพาะสัตว์เลี้ยงในสถานพยาบาล
        </Typography>
        <Typography>
          *สแกน QR code จาก App Bow และ Pet passport สามารถ scan แล้วบันทึกให้ได้ทันทีแม้จะไม่ได้อยู่ในสถานพยาบาล
        </Typography>
      </Box>
    </Box>
    </>
  );
};

export default Search;
